import React from 'react';
import DropshippedProductPriceManagementTable from '../_module/DropshippedProductPriceManagementTable';
import ProductLayout from '../../../../layout/Product';

export default () => (
  <ProductLayout main={<DropshippedProductPriceManagementTable />} />
);
